export const MENTOR_STATUS_NEW = 1;
export const MENTOR_STATUS_AWAITING_RESPONSE = 2;
export const MENTOR_STATUS_ACTIVE = 3;
export const MENTOR_STATUS_INACTIVE = 4;
export const MENTOR_STATUS_REJECTED = 5;
